/**
 * Mobile step menu for Bootstrap
 */
class MobileStepMenu {
	constructor() {
		this.init();
	}

	init() {
		$ = jQuery;
		const self = this;

		$(".dropdown-toggle").on("click", function(e) {
			console.log("Dropdown toggle clicked:", this);
			console.log("Event:", e);
			console.log("Is mobile:", $("body").hasClass("mobile-open"));

			var is_mobile = $("body").hasClass("mobile-open");
			var href = $(this).attr("href");

			if (!is_mobile && href && href !== "#" && href !== "") {
				setTimeout(() => {
					window.location.href = href;
				}, 100);
			}
		});

		$(".toggle-mainmenu").on("click", function(e) {
			e.preventDefault();
			$("body").toggleClass("mobile-open");
		});

		$(window).resize(function() {
			if ($(window).width() >= 600) {
				$("body").removeClass("mobile-open");
				// $('.mega-menu ul').css('display', 'block');
				// $('.mega-menu > ul').css('display', 'none');
				$(".navbar .navbar-nav").removeAttr("style");
			}
		});

		// Safari fix
		$("#site-navbar").on("click", "ul.navbar-nav .dropdown-menu", function(
			e
		) {
			var is_mobile = $("body").hasClass("mobile-open");
			var $list_item = $(e.target);

			console.log("Triggered");

			if (!is_mobile && e.target.tagName == "A") {
				location.href = $list_item.attr("href");
				console.log("Not following link #1");
				return;
			}

			if (!is_mobile) {
				console.log("Not following link #2");
				return false;
			}

			if ($list_item.parent().hasClass("step-back")) {
				var depth = self.getNavigationDepth($list_item, "#site-navbar");
				var previousTitle = $list_item.text();
				var $subMenu = $list_item.parent().find("> .dropdown-menu");

				depth -= 2;

				previousTitle = $list_item
					.parents("li.menu-item-has-children")
					.eq(1)
					.find(" > a")
					.text();
				$subMenu = $list_item
					.parents("li.menu-item-has-children")
					.eq(1)
					.find("> .dropdown-menu");

				e.preventDefault();

				// Transform
				$("#site-navbar > ul.navbar-nav").css(
					"transform",
					"translateX(-" + depth * 100 + "%)"
				);

				// Hide previous sub menus
				$("#site-navbar > ul.navbar-nav .dropdown-menu").hide();

				// Get top most element and display all dropdowns
				$list_item
					.parents("li.menu-item-has-children")
					.each(function() {
						if (
							$(this)
								.parent()
								.hasClass("navbar-nav")
						) {
							$(this)
								.find(".dropdown-menu:not(.sub-menu)")
								.show();
						}
					});
			}
		});

		$("#site-navbar ul.navbar-nav > li.dropdown").on(
			"show.bs.dropdown",
			function(e) {
				var is_mobile = $("body").hasClass("mobile-open");
				var $list_item = $(this).find("> a");
				var $target = $(e.target);

				// Allow normal Bootstrap dropdown behavior on desktop
				if (!is_mobile) {
					return true;
				}

				var depth = self.getNavigationDepth($list_item, "#site-navbar");
				var previousTitle = $list_item.text();
				var $subMenu = $list_item.parent().find("> .dropdown-menu");

				if ($list_item.hasClass("dropdown-toggle")) {
					// Sub-menu ?
					if (!$list_item.parent().hasClass("dropdown-submenu")) {
						// Create a skeleton menu link?
						if (depth >= 0) {
							$(
								"#site-navbar > ul.navbar-nav .step-back"
							).remove();
							$subMenu.prepend(
								'<li class="menu-item step-back d-flex d-md-none"><a href="#">' +
									previousTitle +
									"</a></li>"
							);
						}
					}
				} else if ($list_item.parent().hasClass("step-back")) {
					depth -= 2;

					previousTitle = $list_item
						.parents("li.menu-item-has-children")
						.eq(1)
						.find(" > a")
						.text();
					$subMenu = $list_item
						.parents("li.menu-item-has-children")
						.eq(1)
						.find("> .dropdown-menu");
				} else {
					return true;
				}

				// Check for sub-menu
				if ($target.hasClass("dropdown-submenu")) {
					let $a = $target.find("> a");
					$a.toggleClass("open");
				}

				e.preventDefault();

				// Transform
				$("#site-navbar > ul.navbar-nav").css(
					"transform",
					"translateX(-" + depth * 100 + "%)"
				);

				// Hide previous sub menus
				$("#site-navbar > ul.navbar-nav .dropdown-menu").hide();

				// Get top most element and display all dropdowns
				$list_item
					.parents("li.menu-item-has-children")
					.each(function() {
						if (
							$(this)
								.parent()
								.hasClass("navbar-nav")
						) {
							$(this)
								.find(".dropdown-menu:not(.sub-menu)")
								.show();
						}
					});
			}
		);
	}

	getNavigationDepth(elem, stop) {
		$ = jQuery;

		var $elem = $(elem).parentsUntil(stop);
		var depth = 1;

		$elem.each(function(e) {
			if ($(this).is("ul") && $(this).hasClass("dropdown-menu")) {
				depth++;
			}
		});

		return depth;
	}
}

export default MobileStepMenu;
